module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/james-madison-university-f68da782dbd51f51b4128074d5e1a5d1.svg";